/* eslint-disable no-unused-vars */
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import Select from "react-select";
import * as yup from "yup";
import { emailRegExp } from "../../../../utils/helpers/logicHelper";
import { ManagerService } from "../../../../utils/services/manager.service";

function Body({ domainBrand, phoneCodes, countries, apiTypesArray }) {
  const formRef = useRef();
  const menuPortalTarget = document.getElementById("root");
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [apiProvider, setApiProvider] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const disablePhoneInput = (values) => {
    if (
      typeof values.phoneCountryCode === "undefined" ||
      values.phoneCountryCode === ""
    ) {
      return true;
    } else {
      return false;
    }
  };

  const apiTypesList = apiTypesArray.map((i) => {
    return { label: i, value: i };
  });

  const fetchApiType = async (apiType) => {
    setIsLoading(true);
    try {
      const response = await ManagerService.listApiProviders(apiType);
      if (response.status === 200) {
        const result = response?.data?.data;
        const resultArray =
          result &&
          result.map((i) => {
            return { label: i, value: i };
          });
        setApiProvider([...resultArray]);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      return [];
    }
    setIsLoading(false);
  };

  const schema = yup
    .object({
      country: yup
        .object()
        .shape({
          iso3Code: yup.string(),
          label: yup.string(),
          value: yup.string(),
        })
        .required(),
      connectorType: yup
        .object()
        .shape({
          label: yup.string(),
          value: yup.string(),
        })
        .required(),
      connectorProvider: yup
        .object()
        .shape({
          label: yup.string(),
          value: yup.string(),
        })
        .required(),
      apiName: yup.string().required(),
      addressLine1: yup.string().required(),
      addressLine2: yup.string().required(),
      agentCode: yup.string().required(),
      serialNumberPrefix: yup.string().notRequired(),
      serialNumberLength: yup.number().notRequired(),
      city: yup.string().required(),
      postcode: yup.string().required(),
      email: yup
        .string()
        .email()
        .matches(emailRegExp, "email is not valid")
        .required("Email is required"),
      phoneCodes: yup
        .object()
        .shape({ label: yup.string(), value: yup.string() })
        .required(),
      phone: yup.string().required(),
      extraCredentials: yup.string().required(),
      ignoreDefaultPCNNumber: yup.bool(),
      ignoreDefaultCalculator: yup.bool(),
      message: yup.string().notRequired(),
      apiGatewayURL: yup.string().notRequired(),
      username: yup.string().notRequired(),
      password: yup.string().notRequired(),
      api_key: yup.string().notRequired(),
      merchantID: yup.string().notRequired(),
      apiSecret: yup.string().notRequired(),
      certificatePath: yup.string().notRequired(),
      initiatorName: yup.string().notRequired(),
      certificateText: yup.string().notRequired(),
      partyA: yup.string().notRequired(),
      bearer: yup.string().notRequired(),
      active: yup.bool(),
      currency: yup
        .object()
        .shape({
          label: yup.string(),
          value: yup.string(),
          currencyCode: yup.string(),
        })
        .notRequired(),
    })
    .required();
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    const watchAll = watch(async (data) => {
      if (
        data?.connectorType?.value !== undefined &&
        data?.connectorType?.value !== ""
      ) {
        await fetchApiType(data?.connectorType?.value);
      }
    });
    return () => watchAll.unsubscribe();
  }, [watch]);

  const onSubmit = async (data) => {
    setLoading(true);
    let payload = {
      apiName: data?.apiName,
      agentCode: data?.agentCode,
      serialNumberPrefix: data?.serialNumberPrefix,
      addressLine1: data?.addressLine1,
      serialNumberLength: data?.serialNumberLength,
      addressLine2: data?.addressLine2,
      city: data?.city,
      country: data?.country?.iso3Code,
      phoneNumber: `${data?.phoneCodes?.value}${data?.phone}`,
      email: data?.email,
      postCode: data?.postCode,
      overrideDefaultPcn: data?.ignoreDefaultPCNNumber,
      ignoreDefaultCalculator: data?.ignoreDefaultCalculator,
      apiType: data?.connectorType?.value || "AIRTIME_TOPUP",
      apiProvider: data?.connectorProvider?.value || "CRAFTYCLICKS",
      isActive: data?.active,
      sheAccessbearer: data?.sysBearer,
    };

    if (
      watch("connectorProvider")?.value === "QCELL_AIRTIME" ||
      watch("connectorProvider")?.value === "TRANGLO_API" ||
      watch("connectorProvider")?.value === "NAIRAGRAM_CASHPICKUP_API"
    ) {
      const QCELL_AIRTIME = {
        apiGatewayURL: data?.apiGatewayURL,
        username: data?.username,
        password: data?.password,
        apiKey: data?.api_key,
        apiCredentialExtra: data?.extraCredentials,
      };
      payload = { ...payload, ...QCELL_AIRTIME };
    }

    if (
      watch("connectorProvider")?.value === "SONGHAI_EXCHANGE_BILLPAYMENT" ||
      watch("connectorProvider")?.value === "MFS_AFRICA" ||
      watch("connectorProvider")?.value === "DIRHAM_EXPRESS" ||
      watch("connectorProvider")?.value === "IMPERIAL_FX_API" ||
      watch("connectorProvider")?.value === "CURRENCY_CLOUD" ||
      watch("connectorProvider")?.value === "CASHPOT" ||
      watch("connectorProvider")?.value === "WARI" ||
      watch("connectorProvider")?.value === "MTA2MTA" ||
      watch("connectorProvider")?.value === "TRANSFER_TO_REMITTANCE" ||
      watch("connectorProvider")?.value === "SONGHAI_EXCHANGE_MONEY" ||
      watch("connectorProvider")?.value === "SMALL_WORLD_API" ||
      watch("connectorProvider")?.value === "SIMBA_PAY_API"
    ) {
      const TRANSFER_TO_REMITTANCE = {
        apiCredentialExtra: data?.extraCredentials,
      };
      payload = { ...payload, ...TRANSFER_TO_REMITTANCE };
    }

    if (
      watch("connectorProvider")?.value === "TRANSFER_TO_MOBILE_MONEY" ||
      watch("connectorProvider")?.value === "AFRICASTALKING_REMITTANCE" ||
      watch("connectorProvider")?.value === "PESAPOT_API" ||
      watch("connectorProvider")?.value === "INTELEXPRESS" ||
      watch("connectorProvider")?.value === "FLUTTERWAVE_API" ||
      watch("connectorProvider")?.value === "TERRAPAY" ||
      watch("connectorProvider")?.value === "MORE_MONEY" ||
      watch("connectorProvider")?.value === "MTA2MTA_IN" ||
      watch("connectorProvider")?.value === "SHE_CASH_PICK_UP" ||
      watch("connectorProvider")?.value === "INNOVATE_API" ||
      watch("connectorProvider")?.value === "VENTURE_GARDEN_API" ||
      watch("connectorProvider")?.value === "FLUTTERWAVE_CASHPICKUP_API"
    ) {
      const FLUTTERWAVE_CASHPICKUP_API = {
        apiGatewayURL: data?.apiGatewayURL,
        username: data?.username,
        password: data?.password,
        apiCredentialExtra: data?.extraCredentials,
      };
      payload = { ...payload, ...FLUTTERWAVE_CASHPICKUP_API };
    }

    if (watch("connectorProvider")?.value === "FIRST_APPLE_CASH_PICKUP_API") {
      const FIRST_APPLE_CASH_PICKUP_API = {
        apiGatewayURL: data?.apiGatewayURL,
        apiKey: data?.api_key,
        apiCredentialExtra: data?.extraCredentials,
      };
      payload = { ...payload, ...FIRST_APPLE_CASH_PICKUP_API };
    }

    if (watch("connectorProvider")?.value === "API_2C2P") {
      const API_2C2P = {
        apiGatewayURL: data?.apiGatewayURL,
        username: data?.username,
        password: data?.password,
        apiCredentialExtra: data?.extraCredentials,
        merchantID: data?.merchantID,
        apiSecret: data?.apiSecret,
      };
      payload = { ...payload, ...API_2C2P };
    }

    if (watch("connectorProvider")?.value === "ETRANSACT_CASHPICKUP_API") {
      const ETRANSACT_CASHPICKUP_API = {
        apiGatewayURL: data?.apiGatewayURL,
        username: data?.username,
        password: data?.password,
        apiCredentialExtra: data?.extraCredentials,
        apiKey: data?.api_key,
        apiSecret: data?.apiSecret,
      };
      payload = { ...payload, ...ETRANSACT_CASHPICKUP_API };
    }

    if (
      watch("connectorProvider")?.value === "DAYTONA" ||
      watch("connectorProvider")?.value === "WORLD_REMIT"
    ) {
      const WORLD_REMIT = {
        apiGatewayURL: data?.apiGatewayURL,
        username: data?.username,
        password: data?.password,
        apiCredentialExtra: data?.extraCredentials,
        merchantID: data?.merchantID,
      };
      payload = { ...payload, ...WORLD_REMIT };
    }

    if (watch("connectorProvider")?.value === "MPESA") {
      const MPESA = {
        apiGatewayURL: data?.apiGatewayURL,
        apiKey: data?.api_key,
        apiSecret: data?.apiSecret,
        apiCredentialExtra: data?.extraCredentials,
        partyA: data?.partyA,
        initiatorName: data?.initiatorName,
        certificateText: data?.certificateText,
      };
      payload = { ...payload, ...MPESA };
    }

    if (watch("connectorProvider")?.value === "LHV_PAYOUT") {
      const LHV_PAYOUT = {
        apiGatewayURL: data?.apiGatewayURL,
        apiCredentialExtra: data?.extraCredentials,
        certificatePath: data?.certificatePath,
        username: data?.username,
      };
      payload = { ...payload, ...LHV_PAYOUT };
    }

    if (watch("connectorProvider")?.value === "WORLD_REMIT") {
      const WORLD_REMIT = {
        bearer: data?.bearer,
      };
      payload = { ...payload, ...WORLD_REMIT };
    }

    try {
      const response = await ManagerService.addExternalPayCenter([
        { ...payload },
      ]);
      if (response.status === 200) {
        toast.success(response?.data?.message);
        setLoading(false);
        reset({
          country: {
            iso3Code: "",
            label: "",
            value: "",
          },
          connectorType: {
            label: "",
            value: "",
          },
          connectorProvider: {
            label: "",
            value: "",
          },
          apiName: "",
          addressLine1: "",
          addressLine2: "",
          agentCode: "",
          serialNumberPrefix: "",
          serialNumberLength: "",
          city: "",
          postcode: "",
          email: "",
          phoneCodes: {
            label: "",
            value: "",
          },
          phone: "",
          extraCredentials: "",
          ignoreDefaultPCNNumber: false,
          ignoreDefaultCalculator: false,
          message: "",
          apiGatewayURL: "",
          username: "",
          password: "",
          api_key: "",
          merchantID: "",
          apiSecret: "",
          certificatePath: "",
          initiatorName: "",
          certificateText: "",
          partyA: "",
          bearer: "",
          active: false,
          currency: {
            label: "",
            value: "",
            currencyCode: "",
          },
        });
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title">
              {dictionary
                ? dictionary["WO_SETUP_A_NEW_API_EXT_738805266"]
                : "Setup a new API (External System Integration)"}
            </h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item active" aria-current="page">
                Provide setup details for API (External System Integration).
                This is normally supplied by API provider.
              </li>
            </ol>
          </div>
          <div className="ms-auto pageheader-btn" />
        </div>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12">
            <div className="card overflow-hidden">
              <div className="card-body">
                <form
                  className="needs-validation"
                  onSubmit={handleSubmit(onSubmit)}
                  ref={formRef}
                >
                  {/* 1 */}
                  <div className="form-row">
                    <div className="col-md-6 col-lg-6 mb-3">
                      <label>
                        {dictionary &&
                        dictionary["WO_CONNECTORS_518784763"] !== undefined
                          ? dictionary["WO_CONNECTORS_518784763"]
                          : "Connector(s)"}
                        <span style={{ color: "red" }}> *</span>
                      </label>
                      <input
                        type={"text"}
                        className="form-control border px-3"
                        name="apiName"
                        {...register("apiName", {
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                        })}
                      />
                    </div>

                    <div className="col-md-6 col-lg-6 mb-3">
                      <label>
                        {dictionary
                          ? dictionary["para_address1"]
                          : "Address line 1"}
                        <span style={{ color: "red" }}> *</span>
                      </label>

                      <input
                        type={"text"}
                        className="form-control border px-3"
                        name="addressLine1"
                        {...register("addressLine1", {
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                        })}
                      />
                    </div>

                    <div className="col-md-6 col-lg-6 mb-3">
                      <label>
                        {dictionary
                          ? dictionary["para_address_line_2"]
                          : "Address line 2"}
                      </label>

                      <input
                        type={"text"}
                        className="form-control border px-3"
                        name="addressLine2"
                        {...register("addressLine2", {
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                        })}
                      />
                    </div>

                    <div className="col-md-6 col-lg-6 mb-3">
                      <label>
                        {dictionary
                          ? dictionary["PAYCENTERCOD_914998980"]
                          : "Agent Code"}
                        <span style={{ color: "red" }}> *</span>
                      </label>

                      <input
                        type={"text"}
                        className="form-control border px-3"
                        name="agentCode"
                        {...register("agentCode", {
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                        })}
                      />
                    </div>

                    <div className="col-md-6 col-lg-6 mb-3">
                      <label>
                        {dictionary
                          ? dictionary["WO_SERIAL_NUMBER_PREFI_1429630112"]
                          : "Serial Number Prefix"}
                      </label>

                      <input
                        type={"text"}
                        className="form-control border px-3"
                        name="serialNumberPrefix"
                        {...register("serialNumberPrefix", {
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                        })}
                      />
                    </div>

                    <div className="col-md-6 col-lg-6 mb-3">
                      <label>
                        {dictionary
                          ? dictionary["WO_SERIAL_NUMBER_LENGT_-62039078"]
                          : "Serial Number Length"}
                      </label>

                      <input
                        type={"number"}
                        className="form-control border px-3"
                        name="serialNumberLength"
                        {...register("serialNumberLength", {
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                        })}
                      />
                    </div>

                    <div className="col-md-6 col-lg-6 mb-3">
                      <label>
                        {dictionary
                          ? dictionary["WO_COUNTR_1271562677"]
                          : "Country"}
                      </label>

                      <Controller
                        name="country"
                        control={control}
                        rules={{
                          required: true,
                        }}
                        render={({ field }) => {
                          return (
                            <Select
                              options={countries}
                              isClearable={false}
                              maxMenuHeight={250}
                              menuPlacement="bottom"
                              menuPortalTarget={menuPortalTarget}
                            />
                          );
                        }}
                      />
                    </div>

                    <div className="col-md-6 col-lg-6 mb-3">
                      <label>
                        {dictionary ? dictionary["para_city"] : "City"}
                      </label>
                      <input
                        type="text"
                        name="city"
                        className={`form-control`}
                        {...register("city", {
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                        })}
                      />
                    </div>

                    <div className="col-md-6 col-lg-6 mb-3">
                      <label>
                        {dictionary ? dictionary["para_postcode"] : "Post code"}
                      </label>
                      <input
                        className={`form-control`}
                        type="text"
                        name="postcode"
                        {...register("postcode", {
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                        })}
                      />
                    </div>

                    <div className="col-md-6 col-lg-6 mb-3">
                      <label>
                        {dictionary ? dictionary["l_email"] : "Email"}
                      </label>
                      <input
                        type="text"
                        name="email"
                        className={`form-control`}
                        {...register("email", {
                          required: {
                            value: true,
                            message: "This field is required",
                          },
                        })}
                      />
                    </div>

                    <div className="col-md-6 col-lg-6 mb-3">
                      <div className="form-row">
                        <div className="col-md-5 col-lg-5 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["WO_DIALING_COD_1795023250"]
                              : "Dialing Code"}
                          </label>
                          <Controller
                            name="phoneCodes"
                            control={control}
                            rules={{
                              required: true,
                            }}
                            render={({ field }) => {
                              return (
                                <Select
                                  {...field}
                                  options={phoneCodes}
                                  isClearable={false}
                                  maxMenuHeight={250}
                                  menuPlacement="bottom"
                                  menuPortalTarget={menuPortalTarget}
                                  name="phoneCountryCode"
                                />
                              );
                            }}
                          />
                        </div>
                        <div className="col-md-7 col-lg-7 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["para_phone_number"]
                              : "Phone Number"}
                          </label>
                          <input
                            type="text"
                            name="phone"
                            className={`form-control`}
                            {...register("phone", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* 2 */}
                  <div className="form-row">
                    <div className="col-md-6 col-lg-6 mb-3">
                      <div class="form-check">
                        <input
                          className="form-check-input pe-3"
                          type="checkbox"
                          {...register("ignoreDefaultPCNNumber", {})}
                          // onChange={handleChange}
                        />
                        <label class="form-check-label" for="gridCheck1">
                          {dictionary
                            ? dictionary["WO_IGNORE_DEFAULT_PCN_N_1450428438"]
                            : "Ignore Default PCN Number"}
                        </label>
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-6 mb-3">
                      <div class="form-check">
                        <input
                          className="form-check-input pe-3"
                          type="checkbox"
                          {...register("ignoreDefaultCalculator", {})}
                          // onChange={handleChange}
                        />
                        <label class="form-check-label" for="gridCheck">
                          {dictionary
                            ? dictionary["WO_IGNORE_DEFAULT_CALCU_-1348798292"]
                            : "Ignore Default Calculator"}
                        </label>
                      </div>
                    </div>
                  </div>
                  {/* 3 */}
                  <div className="mt-5 pt-3" />
                  <h5
                    className="text-center pt-5"
                    style={{ letterSpacing: "3px", fontWeight: "bold" }}
                  >
                    SERVICE PROVIDER API CREDENTIALS
                  </h5>
                  <div className="mt-5 pt-3" />
                  <div className="form-row mt-3 mb-3">
                    <div className="col-lg-6 col-md-6 mb-3">
                      <label>
                        {dictionary &&
                        dictionary["WO_CONNECTOR_TYP_1350994000"] !== undefined
                          ? dictionary["WO_CONNECTOR_TYP_1350994000"]
                          : "Connector Type"}
                        <span style={{ color: "red" }}> *</span>
                      </label>

                      <Controller
                        name="connectorType"
                        control={control}
                        rules={{
                          required: true,
                        }}
                        render={({ field }) => {
                          return (
                            <Select
                              {...field}
                              options={apiTypesList}
                              isClearable={false}
                              isSearchable={true}
                              maxMenuHeight={250}
                              menuPlacement="bottom"
                              menuPortalTarget={menuPortalTarget}
                            />
                          );
                        }}
                      />
                    </div>

                    <div className="col-lg-6 col-md-6 mb-3">
                      <label>
                        {dictionary &&
                        dictionary["WO_CONNECTOR_PROVIDE_-366790856"] !==
                          undefined
                          ? dictionary["WO_CONNECTOR_PROVIDE_-366790856"]
                          : "Connector Provider"}
                        <span style={{ color: "red" }}> *</span>
                      </label>
                      <Controller
                        name="connectorProvider"
                        control={control}
                        rules={{
                          required: true,
                        }}
                        render={({ field }) => {
                          return (
                            <Select
                              {...field}
                              options={apiProvider}
                              isClearable={true}
                              isSearchable={true}
                              maxMenuHeight={250}
                              menuPlacement="bottom"
                              menuPortalTarget={menuPortalTarget}
                              isLoading={isLoading}
                            />
                          );
                        }}
                      />
                    </div>

                    {/* WATCH 1*/}
                    {watch("connectorProvider")?.value === "QCELL_AIRTIME" ||
                    watch("connectorProvider")?.value === "TRANGLO_API" ||
                    watch("connectorProvider")?.value ===
                      "NAIRAGRAM_CASHPICKUP_API" ? (
                      <>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["para_gateway_url"] !== undefined
                              ? dictionary["para_gateway_url"]
                              : "Gateway URL"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="apiGatewayURL"
                            {...register("apiGatewayURL", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary && dictionary["l_loginId"] !== undefined
                              ? dictionary["l_loginId"]
                              : "Login ID/User ID/Username"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="username"
                            {...register("username", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["WO_PASSWOR_-1150637439"] !== undefined
                              ? dictionary["WO_PASSWOR_-1150637439"]
                              : "Password"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="password"
                            {...register("password", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary[" WO_CONNECTOR_KE_2131594297"] !==
                              undefined
                              ? dictionary[" WO_CONNECTOR_KE_2131594297"]
                              : "Connector Key"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="api_key"
                            {...register("api_key", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                        <div className="col-lg-6 col-md-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["WO_EXTRA_CREDENTIAL_-1760386648"]
                              : "Extra Credentials"}
                            <span style={{ color: "red" }}> *</span>
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="extraCredentials"
                            {...register("extraCredentials", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    {/* WATCH 2 */}
                    {watch("connectorProvider")?.value ===
                      "SONGHAI_EXCHANGE_BILLPAYMENT" ||
                    watch("connectorProvider")?.value === "MFS_AFRICA" ||
                    watch("connectorProvider")?.value === "DIRHAM_EXPRESS" ||
                    watch("connectorProvider")?.value === "IMPERIAL_FX_API" ||
                    watch("connectorProvider")?.value === "CURRENCY_CLOUD" ||
                    watch("connectorProvider")?.value === "CASHPOT" ||
                    watch("connectorProvider")?.value === "WARI" ||
                    watch("connectorProvider")?.value === "MTA2MTA" ||
                    watch("connectorProvider")?.value ===
                      "TRANSFER_TO_REMITTANCE" ||
                    watch("connectorProvider")?.value ===
                      "SONGHAI_EXCHANGE_MONEY" ||
                    watch("connectorProvider")?.value === "SMALL_WORLD_API" ||
                    watch("connectorProvider")?.value === "SIMBA_PAY_API" ? (
                      <>
                        <div className="col-lg-6 col-md-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["WO_EXTRA_CREDENTIAL_-1760386648"]
                              : "Extra Credentials"}
                            <span style={{ color: "red" }}> *</span>
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="extraCredentials"
                            {...register("extraCredentials", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    {/* WATCH 3 */}
                    {watch("connectorProvider")?.value ===
                      "TRANSFER_TO_MOBILE_MONEY" ||
                    watch("connectorProvider")?.value ===
                      "AFRICASTALKING_REMITTANCE" ||
                    watch("connectorProvider")?.value === "PESAPOT_API" ||
                    watch("connectorProvider")?.value === "INTELEXPRESS" ||
                    watch("connectorProvider")?.value === "FLUTTERWAVE_API" ||
                    watch("connectorProvider")?.value === "TERRAPAY" ||
                    watch("connectorProvider")?.value === "MORE_MONEY" ||
                    watch("connectorProvider")?.value === "MTA2MTA_IN" ||
                    watch("connectorProvider")?.value === "SHE_CASH_PICK_UP" ||
                    watch("connectorProvider")?.value === "INNOVATE_API" ||
                    watch("connectorProvider")?.value ===
                      "VENTURE_GARDEN_API" ||
                    watch("connectorProvider")?.value ===
                      "FLUTTERWAVE_CASHPICKUP_API" ? (
                      <>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["para_gateway_url"] !== undefined
                              ? dictionary["para_gateway_url"]
                              : "Gateway URL"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="apiGatewayURL"
                            {...register("apiGatewayURL", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary && dictionary["l_loginId"] !== undefined
                              ? dictionary["l_loginId"]
                              : "Login ID/User ID/Username"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="username"
                            {...register("username", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["WO_PASSWOR_-1150637439"] !== undefined
                              ? dictionary["WO_PASSWOR_-1150637439"]
                              : "Password"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="password"
                            {...register("password", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-lg-6 col-md-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["WO_EXTRA_CREDENTIAL_-1760386648"]
                              : "Extra Credentials"}
                            <span style={{ color: "red" }}> *</span>
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="extraCredentials"
                            {...register("extraCredentials", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    {/* WATCH 4 */}
                    {watch("connectorProvider")?.value ===
                    "FIRST_APPLE_CASH_PICKUP_API" ? (
                      <>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary[" WO_CONNECTOR_KE_2131594297"] !==
                              undefined
                              ? dictionary[" WO_CONNECTOR_KE_2131594297"]
                              : "Connector Key"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="api_key"
                            {...register("api_key", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["para_gateway_url"] !== undefined
                              ? dictionary["para_gateway_url"]
                              : "Gateway URL"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="apiGatewayURL"
                            {...register("apiGatewayURL", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                        <div className="col-lg-6 col-md-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["WO_EXTRA_CREDENTIAL_-1760386648"]
                              : "Extra Credentials"}
                            <span style={{ color: "red" }}> *</span>
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="extraCredentials"
                            {...register("extraCredentials", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    {/* WATCH 5 */}
                    {watch("connectorProvider")?.value === "API_2C2P" ? (
                      <>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["para_gateway_url"] !== undefined
                              ? dictionary["para_gateway_url"]
                              : "Gateway URL"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="apiGatewayURL"
                            {...register("apiGatewayURL", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary && dictionary["l_loginId"] !== undefined
                              ? dictionary["l_loginId"]
                              : "Login ID/User ID/Username"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="username"
                            {...register("username", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["WO_PASSWOR_-1150637439"] !== undefined
                              ? dictionary["WO_PASSWOR_-1150637439"]
                              : "Password"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="password"
                            {...register("password", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["l_merchantid"] !== undefined
                              ? dictionary["l_merchantid"]
                              : "Merchant/Client ID"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="merchantID"
                            {...register("merchantID", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>API Secret</label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="apiSecret"
                            {...register("apiSecret", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                        <div className="col-lg-6 col-md-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["WO_EXTRA_CREDENTIAL_-1760386648"]
                              : "Extra Credentials"}
                            <span style={{ color: "red" }}> *</span>
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="extraCredentials"
                            {...register("extraCredentials", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    {/* WATCH 6 */}
                    {watch("connectorProvider")?.value ===
                    "ETRANSACT_CASHPICKUP_API" ? (
                      <>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["para_gateway_url"] !== undefined
                              ? dictionary["para_gateway_url"]
                              : "Gateway URL"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="apiGatewayURL"
                            {...register("apiGatewayURL", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary && dictionary["l_loginId"] !== undefined
                              ? dictionary["l_loginId"]
                              : "Login ID/User ID/Username"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="username"
                            {...register("username", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["WO_PASSWOR_-1150637439"] !== undefined
                              ? dictionary["WO_PASSWOR_-1150637439"]
                              : "Password"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="password"
                            {...register("password", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary[" WO_CONNECTOR_KE_2131594297"] !==
                              undefined
                              ? dictionary[" WO_CONNECTOR_KE_2131594297"]
                              : "Connector Key"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="api_key"
                            {...register("api_key", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>API Secret</label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="apiSecret"
                            {...register("apiSecret", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                        <div className="col-lg-6 col-md-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["WO_EXTRA_CREDENTIAL_-1760386648"]
                              : "Extra Credentials"}
                            <span style={{ color: "red" }}> *</span>
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="extraCredentials"
                            {...register("extraCredentials", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    {/* WATCH 7 */}
                    {watch("connectorProvider")?.value === "DAYTONA" ||
                    watch("connectorProvider")?.value === "WORLD_REMIT" ? (
                      <>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["para_gateway_url"] !== undefined
                              ? dictionary["para_gateway_url"]
                              : "Gateway URL"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="apiGatewayURL"
                            {...register("apiGatewayURL", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary && dictionary["l_loginId"] !== undefined
                              ? dictionary["l_loginId"]
                              : "Login ID/User ID/Username"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="username"
                            {...register("username", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["WO_PASSWOR_-1150637439"] !== undefined
                              ? dictionary["WO_PASSWOR_-1150637439"]
                              : "Password"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="password"
                            {...register("password", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["l_merchantid"] !== undefined
                              ? dictionary["l_merchantid"]
                              : "Merchant/Client ID"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="merchantID"
                            {...register("merchantID", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-lg-6 col-md-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["WO_EXTRA_CREDENTIAL_-1760386648"]
                              : "Extra Credentials"}
                            <span style={{ color: "red" }}> *</span>
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="extraCredentials"
                            {...register("extraCredentials", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    {/* WATCH 8 */}
                    {watch("connectorProvider")?.value === "MPESA" ? (
                      <>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["para_gateway_url"] !== undefined
                              ? dictionary["para_gateway_url"]
                              : "Gateway URL"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="apiGatewayURL"
                            {...register("apiGatewayURL", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary[" WO_CONNECTOR_KE_2131594297"] !==
                              undefined
                              ? dictionary[" WO_CONNECTOR_KE_2131594297"]
                              : "Connector Key"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="api_key"
                            {...register("api_key", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>API Secret</label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="apiSecret"
                            {...register("apiSecret", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-lg-6 col-md-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["WO_EXTRA_CREDENTIAL_-1760386648"]
                              : "Extra Credentials"}
                            <span style={{ color: "red" }}> *</span>
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="extraCredentials"
                            {...register("extraCredentials", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-lg-6 col-md-6 mb-3">
                          <label>Initiator Name</label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="initiatorName"
                            {...register("initiatorName", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-lg-6 col-md-6 mb-3">
                          <label>Party A</label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="partyA"
                            {...register("partyA", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>

                        <div className="col-lg-6 col-md-6 mb-3 pt-4">
                          <label>Certificate (copy & paste )</label>
                          <textarea
                            className="form-control px-3 py-4"
                            // value={values.sysBearer}
                            name="certificateText"
                            {...register("certificateText", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    {/* WATCH 9 */}
                    {watch("connectorProvider")?.value === "LHV_PAYOUT" && (
                      <>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary && dictionary["l_loginId"] !== undefined
                              ? dictionary["l_loginId"]
                              : "Login ID/User ID/Username"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="username"
                            {...register("username", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                        <div className="col-md-6 col-lg-6 mb-3">
                          <label>
                            {dictionary &&
                            dictionary["para_gateway_url"] !== undefined
                              ? dictionary["para_gateway_url"]
                              : "Gateway URL"}
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="apiGatewayURL"
                            {...register("apiGatewayURL", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                        <div className="col-lg-6 col-md-6 mb-3 pt-4">
                          <label>Certificate Path</label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="certificatePath"
                            {...register("certificatePath", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                        <div className="col-lg-6 col-md-6 mb-3">
                          <label>
                            {dictionary
                              ? dictionary["WO_EXTRA_CREDENTIAL_-1760386648"]
                              : "Extra Credentials"}
                            <span style={{ color: "red" }}> *</span>
                          </label>
                          <input
                            type={"text"}
                            className="form-control border px-3"
                            name="extraCredentials"
                            {...register("extraCredentials", {
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            })}
                          />
                        </div>
                      </>
                    )}

                    {/* WATCH 10 */}
                    {watch("connectorProvider")?.value !== "MPESA" && (
                      <div className="col-lg-6 col-md-6 mb-3 pt-4">
                        <label>
                          System Bearer (copy & paste: This value will be
                          provided by MTA. )
                        </label>
                        <textarea
                          className="form-control px-3 py-4"
                          // value={values.sysBearer}
                          name="sysBearer"
                          {...register("sysBearer", {
                            required: {
                              value: true,
                              message: "This field is required",
                            },
                          })}
                        />
                      </div>
                    )}

                    {/* WATCH 11 */}
                    {watch("connectorProvider")?.value === "WORLD_REMIT" && (
                      <div className="col-lg-6 col-md-6 mb-3 pt-4">
                        <label>Bearer (copy & paste)</label>
                        <textarea
                          className="form-control px-3 py-4"
                          // value={values.sysBearer}
                          name="bearer"
                          {...register("bearer", {
                            required: {
                              value: true,
                              message: "This field is required",
                            },
                          })}
                        />
                      </div>
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <input
                      className="form-input pe-2 me-2"
                      type={"checkbox"}
                      {...register("active", {})}
                    />

                    <label className="">Active</label>
                  </div>
                  <div className="col-lg-6 col-md-6 float-end mb-5 pb-5">
                    <button
                      className="login100-form-btn btn-primary"
                      type={"submit"}
                    >
                      {dictionary ? dictionary["b_register"] : "Register"}
                      &nbsp;&nbsp;
                      {loading ? (
                        <>
                          &nbsp;
                          <i className="fa fa-spinner fa-spin" />
                        </>
                      ) : (
                        ""
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Body;
